import styled, { css } from 'styled-components';
import { theme } from 'styles';
import check from 'assets/icons/common/check.svg';
import disabledCheck from 'assets/icons/common/check_disabled.svg';

const types = {
  enabled: css`
    border: 1px solid ${theme.colors.darkGray};
    background-color: #ffffff;
  `,
  hovered: css`
    border: 1px solid ${theme.colors.darkGray};
    background-color: ${theme.colors.lightGray};
  `,
  focused: css`
    border: 1px solid ${theme.colors.primary200};
    background-color: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(40, 191, 194, 0.5);
  `,
  active: css`
    background-color: ${theme.colors.lighterGray};
    border: 1px solid ${theme.colors.darkGray};
  `,
  disabled: css`
    border: 1px solid ${theme.colors.lighterGray};
    background-color: ${theme.colors.lightGray};
  `,
};

export const CheckboxField = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  appearance: none;
  border-radius: 4px;
  position: relative;
  display: inline-block;

  ${({ disabled }) => (disabled ? types.disabled : types.enabled)}

  &:hover:not(:disabled) {
    ${types.hovered}
  }

  &:active:not(:disabled) {
    ${types.active}
  }

  &:focus-visible:not(:disabled) {
    ${types.focused}
    outline: none;
  }

  &:checked {
    background-color: ${theme.colors.primary600};
    border-color: ${theme.colors.primary600};
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 14px 10px;

    &:hover {
      border: 1px solid ${theme.colors.primary800};
      background-color: ${theme.colors.primary800};
    }

    &:focus-visible:not(:disabled) {
      border: 1px solid ${theme.colors.primary200};
      background-color: ${theme.colors.primary300};
      box-shadow: 0px 0px 2px 0px #28bfc2;
      outline: none;
    }

    &:active:not(:disabled) {
      border: 1px solid ${theme.colors.primary900};
      background-color: ${theme.colors.primary900};
    }

    &:disabled {
      border: 1px solid ${theme.colors.primary100};
      background-color: ${theme.colors.primary100};
      background-image: url(${disabledCheck});
    }
  }
`;
